/** Shared session context types (mirrors extension session-context.types). */

export interface SessionDomainRule {
  host: string;
  includeSubpaths: boolean;
}

export interface SessionContextRules {
  description?: string;
  keywords?: string[];
  domains?: SessionDomainRule[];
  strictMode?: boolean;
  useAiAssist?: boolean | null;
  suggestRuleLearning?: boolean | null;
}

export type SessionContextAutomationMode = 'manual' | 'prompt_on_switch';

export interface SessionContextGlobalConfig {
  enabled: boolean;
  automationMode: SessionContextAutomationMode;
  useAiAssist: boolean;
  showStrayTabBadge: boolean;
  suggestRuleLearning: boolean;
}

export type CategorizeMatchedBy =
  | 'domain'
  | 'keyword'
  | 'category'
  | 'ai'
  | 'quick_browse'
  | 'conflict';

export interface CategorizeAssignment {
  logicalTabId: string;
  chromeTabId: number;
  title: string;
  host: string;
  sourceSid: string;
  sourceSessionName: string;
  targetSid: string;
  targetSessionName: string;
  matchedBy: CategorizeMatchedBy;
  confidence: number;
  defaultChecked: boolean;
  conflict?: boolean;
  candidateTargetSids?: string[];
  included?: boolean;
}

export interface CategorizePreviewResult {
  assignments: CategorizeAssignment[];
  strayCount: number;
  quickBrowseSid: string | null;
}

export interface CategorizeApplyResult {
  applied: number;
  failed: Array<{ logicalTabId: string; error: string }>;
  undoAvailableUntil: number | null;
}

export const DEFAULT_SESSION_CONTEXT_GLOBAL_CONFIG: SessionContextGlobalConfig =
  {
    enabled: false,
    automationMode: 'manual',
    useAiAssist: false,
    showStrayTabBadge: true,
    suggestRuleLearning: true,
  };
